import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UsersService } from '../services/users.service';
import { Router } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  allUserData:any[]
  currentUser ;
  @Output()gotoprofile = new EventEmitter();
  @Output()changView = new EventEmitter();
  required:boolean = false  ; validEmail:boolean = false  ;matchEmail :boolean = false ;matchPassword:boolean = false ;emptyPassword:boolean=false ;
  constructor(private allUsers:UsersService, private router:Router) { }

  ngOnInit() {
  }

  checkAll()
  {

    var i = 0 ; 
    var mailValue = (<HTMLInputElement>document.getElementById('email')).value ; 
    var passwordValue = (<HTMLInputElement>document.getElementById('password')).value ;
    if(mailValue === '')
    {
      this.required = true ; 
      this.validEmail = false  
      this.matchEmail  = false 
      this.matchPassword  = false ; 
    
      i += 1 ; 

    }
    else if(mailValue.toString().indexOf('@') === -1 )
    {
      this.required = false ; 
      this.validEmail = true  
      this.matchEmail  = false 
      this.matchPassword  = false ; 
      
      i += 1 
    }
    else if( !this.checkEmail(mailValue))
    {
      this.required = false ; 
      this.validEmail =   false ;
      this.matchEmail  = true
      this.matchPassword  = false ;
      i+= 1 
    }
 

    else
    {
      
      this.required = false ; 
      this.validEmail = false 
      this.matchEmail  = false 
      this.matchPassword  = false ; 
      
      
    }

    if(passwordValue.toString() === "")
    {
      this.emptyPassword = true  ;
      this.matchPassword = false ;
    
      i += 1 
    }
   else if(this.checkEmail(mailValue))
   {
     if(! this.checkPassword(mailValue,passwordValue))
     {
      this.emptyPassword = false   ;
      this.matchPassword = true;
      this.matchEmail = false 
      i += 1 
     }
      
    
     
   }
    else
    {
      this.emptyPassword = false  ; 
      this.matchPassword  = false  ;
``
      
    }
    
    if(i>0)
    {
      document.getElementById("log").classList.add('animated', 'bounce')
      setTimeout(function(){
        document.getElementById('log').classList.remove('bounce')
      },1000)
    }
    else
    {
      for(let curr of this.allUsers.users)
      {
        if(curr.email === mailValue)
        {
          this.allUsers.currentUser = curr.id ; 
        
          break ;
        }
      }
      (<HTMLFormElement>document.getElementById('log')).reset()
      this.gotoprofile.emit()
      this.changView.emit()
      this.allUsers.showNavbar = true 
      this.router.navigate[("/login")]
    }
    
  }
 
  checkPassword(mailValue,passwordValue):boolean
  {
    for(let myUser of this.allUsers.users)
    {
      if(myUser.email === mailValue)
      {
        if(myUser.password === passwordValue)
        {
          return true 
          break 
        }
      }
    }
  }

  checkEmail(mailValue):boolean
  {
    this.allUserData = this.allUsers.users ; 
    for(let user of this.allUserData)
    {
      if(user.email === mailValue)
      {
        return true 
        break ;
      }
    }
  }


  
 
}
